import React, { useState, useEffect } from "react";
import { Box, Modal, Typography, FormControlLabel, Checkbox } from "@mui/material";
import Close from "../../../Components/Icons/Close";
import CustomInput from "../../../Subcomponents/CustomInput";
import Button from "../../../Subcomponents/Button";
import ConfirmationAlert from "../../../Subcomponents/ConfirmationAlert";
import { useSelector } from "react-redux";
import RupeeIcon from "../../../Assets/Images/Sustenance/RupeeIcon.svg";
import { UpdateFarvisionStatus } from "../../../Services/Event";
import { UpdateInventoryStatusToAvailable, insertInventoryLog } from "../../../Services/Event";
import { presentLoader, dismissLoader } from "../../../Services/loader";
import { successTost, errorTost } from "../../../Services/Toast";
import cssClasses from './HoldModule.module.css';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";

export default function HoldModal({
  open,
  unitData,
  onClose,
  updatePrice,
  returnRes,
}) {
  const loggedInUser = useSelector(state => state.Auth.user);

  const [updateUnitPrice, setUpdateUnitPrice] = useState({
    bsp: "",
    sdr: 0,
    gst: 0,
    total: 0,
  });
  const [skipChanges, setSkipChanges] = useState(false);
  const [openAlertConfimation, setOpenAlertConfimation] = useState(false);
  const [releaseNote, setReleaseNote] = useState("");

  console.log("unitData", unitData);
  
  console.log("unitData?.projectAdditionalConfiguration?.isCommercial", unitData?.projectAdditionalConfiguration?.isCommercial);
  const calculateUnitPrice = (bsp, unitData) => {
    if (!bsp || isNaN(bsp)) {
      return { bsp: "", sdr: 0, gst: 0, total: 0 };
    }


    const sdr = Math.ceil(
      (
        (bsp * (unitData?.sdrPercentage || 7)) / 100 +
        (bsp / 100 > unitData.registrationCharges ? unitData.registrationCharges : bsp / 100) +  // replaced 30000 with registrationCharges
        (unitData?.legalCharges || 0)
      ) / 100

    ) * 100;

    // Calculate GST: commercial units use gstPercentage from
    // ProjectAdditionalConfiguration (falling back to 12% if not yet configured);
    // non-commercial units keep the hardcoded 1%/5% rule
    const gst = unitData?.projectAdditionalConfiguration?.isCommercial
      ? Math.round((bsp * Number(unitData?.projectAdditionalConfiguration?.gstPercentage ?? 12)) / 100)
      : bsp < 4500000
        ? Math.round(bsp / 100)      // 1% GST for BSP < 4.5M
        : Math.round((bsp * 5) / 100);  // 5% GST otherwise

    return {
      bsp,
      sdr,
      gst,
      total: bsp + sdr + gst,
    };
  };
  useEffect(() => {
    if (!unitData) return;

    const initialBsp = Number(updatePrice?.bsp) || Number(unitData.BSP) || 0;
    const calculated = calculateUnitPrice(initialBsp, unitData);

    setUpdateUnitPrice(calculated);
  }, [unitData, updatePrice]);

  useEffect(() => {
    if (!unitData) return;

    const initialBsp =
      Number(updatePrice?.bsp) ||
      Number(unitData.BSP) ||
      Number(unitData.bsp) ||
      0;

    const calculated = calculateUnitPrice(initialBsp, unitData);

    setUpdateUnitPrice(calculated);
  }, [unitData, updatePrice, unitData.inventoryStatusId]);


  const handleBSPChange = (value) => {
    if (value === "") {
      setUpdateUnitPrice({ bsp: "", sdr: 0, gst: 0, total: 0 });
      return;
    }

    if (isNaN(value)) return;

    const bsp = Number(value);
    const calculated = calculateUnitPrice(bsp, unitData);

    setUpdateUnitPrice(calculated);
  };


  const numberWithCommas = (x) => x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const handleUpdate = async () => {
    presentLoader();

    try {
      if (unitData.inventoryStatusId?.status !== "Reserved") {
        throw new Error("Unit is not Reserved");
      }

      // ✅ 1. INSERT INVENTORY LOG
      await insertInventoryLog({
        unitId: unitData.unitId,                // uuid ✅
        leadId: unitData.leadId || null,        // uuid ✅
        userId: loggedInUser?.id,               // uuid ✅
        eventId: unitData.eventId || null,      // uuid ✅
        projectId: unitData.projectId,          // uuid ✅

        pricingType: "Agreement Value Update",
        status: "Available",
        unitStatusChangeReason: releaseNote || "Unit released from Hold",
        holdReason: unitData.holdReason || null,

        eventTokenId: unitData.eventTokenId || null,

        created_at: Date.now(),
        last_updated_at: Date.now(),
      });


      // ✅ 2. UPDATE FARVISION PRICE
      await UpdateFarvisionStatus(
        unitData.unitId,
        {
          bsp: Number(updateUnitPrice.bsp),
          gst: updateUnitPrice.gst,
          sdr: updateUnitPrice.sdr,
          total: updateUnitPrice.total,
        }
      );
      await UpdateInventoryStatusToAvailable(unitData.unitId);

      // ✅ 4. NOTIFY PARENT
      returnRes?.({
        success: true,
        unitId: unitData.unitId,
        newStatus: "Available",
        updatedUnitPrice: updateUnitPrice,
        last_updated_at: Date.now(),
      });

      successTost("Unit released and marked Available");
      onClose();

    } catch (err) {
      console.error("Inventory Log Error:", err);
      errorTost(err.message || "Error updating unit");
    } finally {
      dismissLoader();
    }
  };



  if (!unitData) return null;
  const isHoldReleaseAccessible =
    loggedInUser?.roleId?.accessibleTabs?.["Hold/Release"]?.Release?.isAccessible;



  return (
 <Modal
  open={open}
  onClose={(_, reason) => reason !== "backdropClick" && onClose()}
  aria-labelledby="modal-title"
  aria-describedby="modal-description"
 sx={{
    ".MuiBackdrop-root": { background: "rgba(52, 64, 84, 0.7)" },
    "& .MuiPaper-root": {
      minWidth: "500px", // Set maxWidth here
      maxWidth: "500px",
      // width: "100%", // Ensure it doesn't overflow
      margin: "auto", // Center the modal
    },
  }}
  disableAutoFocus

>
      <Box className={cssClasses.modalWrapper}>
        {/* Header */}
        <Box className={cssClasses.wrapperHeader}>
          <Typography fontSize="2rem" fontWeight={500}>
            Reserved Unit
          </Typography>
          <Box onClick={onClose} sx={{ position: "absolute", top: "1.7rem", right: "1.7rem", cursor: "pointer" }}>
            <Close width="1.2rem" height="1.2rem" />
          </Box>
        </Box>

        {/* Project & Unit Info */}
        <Box className={cssClasses.projectDataWrapper}>
          <Typography fontWeight={500} fontFamily="Inter-Medium" fontSize={14} sx={{ marginBottom: 1 }}>
            {unitData.wingName} | {unitData.projectName}
          </Typography>
          <Typography fontWeight={500} fontFamily="Inter-Medium" fontSize={14} sx={{ marginBottom: 1 }}>
            Unit Type: {unitData.unitType} | Unit No:{unitData.unitNo}
          </Typography>
          <Typography fontWeight={500} fontFamily="Inter-Medium" fontSize={14} sx={{ marginBottom: 1 }}>
            Carpet Area(Sq.ft): {unitData.chargeableArea} &nbsp;&nbsp; Saleable Area(Sq.ft): {unitData.saleableArea}
          </Typography>
          <Typography fontWeight={500} fontFamily="Inter-Medium" fontSize={14} sx={{ marginBottom: 1 }}>
            Reserved by: {unitData?.userName || "N/A"}
          </Typography>
        </Box>


        {/* Unit Prices */}
        <Box className={cssClasses.wrapperContent}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "1.6rem", marginRight: "0rem" }}>
          <Box className={cssClasses.wrapperBlock}>
            <CustomInput
              value={updateUnitPrice.bsp}
              handleChange={handleBSPChange}
              label="Agreement Value"
              inputType="text"
              labelText={RupeeIcon}
            />
          </Box>
          <Box className={cssClasses.wrapperBlock}>
            <CustomInput
              value={updateUnitPrice.gst}
              disabled
              label={`GST (${unitData?.projectAdditionalConfiguration?.isCommercial
                ? `${Number(unitData?.projectAdditionalConfiguration?.gstPercentage ?? 12)}%`
                : Number(updateUnitPrice?.bsp) < 4500000
                  ? "1%"
                  : "5%"
                })`}
              inputType="text"
              labelText={RupeeIcon}
            />
          </Box>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "1.6rem", marginRight: "0rem" }}>
          <Box className={cssClasses.wrapperBlock}>
            <CustomInput
              value={updateUnitPrice.sdr}
              disabled
              label="SDR (7%) + Fee"
              inputType="text"
              labelText={RupeeIcon}
            />
          </Box>
          <Box className={cssClasses.wrapperBlock}>
            <CustomInput
              value={updateUnitPrice.total}
              disabled
              label="Total"
              inputType="number"
              labelText={RupeeIcon}
            />
          </Box>
          </Box>
        </Box>

        {/* Skip Changes */}
        {/* <FormControlLabel
          control={<Checkbox checked={skipChanges} onChange={() => setSkipChanges(!skipChanges)} />}
          label="Skip changes"
          sx={{ ml: 3 }}
        /> */}

        {/* Footer Buttons */}
        <Box className={cssClasses.wrapperFooter}>
          <Button
            btnName="Cancel"
            clicked={onClose}
            style={{ color: "#344054", backgroundColor: "#ffffff", fontSize: "1.6rem" }}
          />
          <Button
            btnName="Update"
            clicked={() => {
              if (!isHoldReleaseAccessible) return;
              setOpenAlertConfimation(true);
            }}
            disabled={!isHoldReleaseAccessible}
            style={{
              color: "#ffffff",
              backgroundColor: isHoldReleaseAccessible ? "#155EEF" : "#9CA3AF",
              fontSize: "1.6rem",
              cursor: isHoldReleaseAccessible ? "pointer" : "not-allowed",
              pointerEvents: isHoldReleaseAccessible ? "auto" : "none",
            }}
          />




        </Box>

        {/* Confirmation Alert */}
        <Dialog
          open={openAlertConfimation}
          onClose={() => setOpenAlertConfimation(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ fontSize: "1.8rem", fontWeight: 600 }}>
            Confirm Release
          </DialogTitle>

          <DialogContent>
            <Typography sx={{ mb: 2, fontSize: "1.4rem" }}>
              Do you want to update unit price and release this unit?
            </Typography>

            <CustomInput
              label="Note / Reason"
              value={releaseNote}
              handleChange={(val) => setReleaseNote(val)}
              inputType="text"
              placeholder="Enter release note"
            />
          </DialogContent>

          <DialogActions sx={{ padding: "1.6rem 2.4rem" }}>
            <Button
              btnName="Cancel"
              clicked={() => {
                setOpenAlertConfimation(false);
                setReleaseNote("");
              }}
              style={{
                backgroundColor: "#ffffff",
                color: "#344054",
                fontSize: "1.4rem",
              }}
            />

            <Button
              btnName="Yes, Release"
              clicked={() => {
                if (!releaseNote.trim()) {
                  errorTost("Please enter a note");
                  return;
                }
                handleUpdate();
              }}
              style={{
                backgroundColor: "#155EEF",
                color: "#ffffff",
                fontSize: "1.4rem",
              }}
            />
          </DialogActions>
        </Dialog>


      </Box>
    </Modal>
  );
}